var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3085 19.1909L16.1675 21.2999C15.0511 20.6262 14.0139 19.8292 13.0755 18.9239C12.1719 17.9849 11.3754 16.9486 10.7005 15.8339L12.8105 13.6929C12.9371 13.5634 13.0226 13.3994 13.0562 13.2215C13.0899 13.0435 13.0701 12.8596 12.9995 12.6929L10.8005 7.55988C10.7136 7.35768 10.5569 7.19343 10.359 7.09707C10.1612 7.0007 9.93525 6.97863 9.72247 7.03488L5.68847 8.09988C5.4865 8.15222 5.30836 8.27172 5.18332 8.43874C5.05828 8.60576 4.9938 8.81035 5.00047 9.01888C5.25738 13.7103 7.20814 18.1491 10.4905 21.5109C13.8534 24.7937 18.2938 26.7442 22.9865 26.9999C23.1947 27.0065 23.3991 26.9419 23.5657 26.8168C23.7324 26.6918 23.8515 26.5137 23.9035 26.3119L24.9695 22.2759C25.026 22.0632 25.0042 21.8373 24.908 21.6394C24.8118 21.4415 24.6476 21.2848 24.4455 21.1979L19.3165 18.9999C19.1486 18.9276 18.9629 18.9072 18.7833 18.9412C18.6037 18.9753 18.4383 19.0622 18.3085 19.1909V19.1909Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5C20.3869 5 22.6761 5.94821 24.364 7.63604C26.0518 9.32387 27 11.6131 27 14",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9C19.3261 9 20.5979 9.52678 21.5355 10.4645C22.4732 11.4021 23 12.6739 23 14",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/Call.3393d130.svg";
export { ForwardRef as ReactComponent };